export default __webpack_public_path__ + "static/media/promo-banner-razer.4ce01915.svg";